<template>
  <div class="footer">

    <AccesskeyLink target="accesskey_b" accesskey="b" :aria-label="$t('頁尾網頁資訊')">
      {{ $t(':::') }}
    </AccesskeyLink>

    <div class="container">


      <div class="box">

        <div class="logo_box">
          <img :src="logoUrl" alt="">
        </div>

        <div data-layout-tab="HeaderFooter" data-layout-item="FooterInfoL" v-html="footerInfoL"></div>
      </div>

      <div data-layout-tab="HeaderFooter" data-layout-item="FooterInfoR" v-html="footerInfoR"></div>


      <!-- 回頂端 -->
      <div :class="['float_top', { 'add': isTop }]">
        <button @click="scrollToAwardsTop" class="top_btn">
          <p>{{ $t('TOP') }}</p>
        </button>
      </div>


    </div>

    <div class="bottom">
      <p>{{ $t('CopyRight©2026') }}</p>
    </div>

  </div>
</template>

<script>

import AccesskeyLink from '@/views/AccesskeyLink.vue'

export default {
  name: 'Footer',
  components: {

    AccesskeyLink
  },

  data() {
    return {

      // 站台圖示
      logoUrl: 'img/logo.png',

      // 版面配置內容
      footerInfoL: null,
      footerInfoR: null,

      // 社交軟體
      socialItem: [
        {
          title: "FB",
          src: require('/public/img/fb_green.svg'),
          href: "https://www.facebook.com/longtianchacha"
        },
        {
          title: "IG",
          src: require('/public/img/ig_green.svg'),
          href: "https://www.instagram.com/longtian_chacha/"
        },
        {
          title: "YOUTUBE",
          src: require('/public/img/youtube_green.svg'),
          href: "https://www.youtube.com/channel/UC0JaFGw0FwjZVsmt2bTJ6ew"
        },
      ],

      // 頁尾連結
      footerLinkItems: [
        {
          title: "隱私權及安全政策",
          to: "/",
        },
        {
          title: "網站資料開放宣告",
          to: "/",
        },
      ],


      // 回到頂端
      isTop: false,
    };
  },

  mounted() {
    // 取得站台圖示
    this.fetchSiteFavicon();

    // 取得版面配置
    this.fetchLayout();

    // 在組件加載完成後監聽滾動事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 組件銷毀之前移除滾動事件監聽
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    '$i18n.locale': function() {
      // 語系切換時重新載入配置
      this.fetchSiteFavicon();
      this.fetchLayout();
    }
  },

  methods: {
    applyLayoutVisualItem({ tabKey, item }) {
      if (tabKey !== 'HeaderFooter') return;
      if (item.itemKey === 'FooterInfoL') this.footerInfoL = item.textContent || '';
      if (item.itemKey === 'FooterInfoR') this.footerInfoR = item.textContent || '';
    },

    // 轉換前端語系名稱為後端格式
    convertLocaleForBackend(frontendLocale) {
      const localeMap = {
        'zh-TW': 'zh-tw',
        'en': 'en-us',
        'ja': 'ja-jp'
      };
      return localeMap[frontendLocale] || 'zh-tw';
    },

    // API: 取得站台圖示
    async fetchSiteFavicon() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetSiteFavicon`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得站台圖示，使用預設值');
          return;
        }
        
        const data = await response.json();
        
        if (data.faviconUrl) {
          this.logoUrl = `${this.$store.state.src}${this.$store.state.subDirectory}${data.faviconUrl}`;
        }
      } catch (error) {
        console.warn('載入站台圖示失敗，使用預設值:', error);
      }
    },

    // API: 取得版面配置
    async fetchLayout() {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetLayout?TabKey=HeaderFooter&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得版面配置，清空頁尾資料');
          this.footerInfoL = null;
          this.footerInfoR = null;
          return;
        }
        
        const layout = await response.json();
        
        // 處理 layoutItems
        if (layout.layoutItems && Array.isArray(layout.layoutItems)) {
          // 先清空
          this.footerInfoL = null;
          this.footerInfoR = null;
          
          layout.layoutItems.forEach(item => {
            // itemType = 4 表示文字編輯器內容
            if (item.itemType === 4 && item.textContent) {
              if (item.itemKey === 'FooterInfoL') {
                this.footerInfoL = item.textContent;
              } else if (item.itemKey === 'FooterInfoR') {
                this.footerInfoR = item.textContent;
              }
            }
          });
        } else {
          this.footerInfoL = null;
          this.footerInfoR = null;
        }
      } catch (error) {
        console.error('載入版面配置失敗:', error);
        this.footerInfoL = null;
        this.footerInfoR = null;
      }
    },

    // 回頂端
    handleScroll() {
      // 判斷頁面滾動的高度來顯示/隱藏按鈕
      if (window.scrollY > 500) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    scrollToAwardsTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },

  },

}

</script>
